import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Input from '../../components/ui/Input.jsx';
import { customersApiService } from '../../services';

function Fax({ tabColors = { bgcolor: 'bg-pink-300', nocolor: 'bg-pink-100', hovercolor: 'hover:bg-pink-200' } }) {
  const { id } = useParams();
  const [, setTicket] = useState(null);

  useEffect(() => {
    if (id) {
      customersApiService.getTicketById(id)
        .then(async data => {
          // Fetch fresh customer data to avoid stale cached names
          let customerName = data.customer_name;
          try {
            const customer = await customersApiService.getCustomerByNumber(data.customer_number);
            if (customer && customer.customer_name) {
              customerName = customer.customer_name;
            }
          } catch (err) {
            console.warn('Could not fetch fresh customer data, using cached name:', err);
          }

          setTicket(data);
          const pageTitle = `${data.ticket_number} - ${customerName} - ${data.issue_with}`;
          document.title = pageTitle;
        })
        .catch(err => {
          console.error('Error fetching ticket:', err);
          document.title = 'SSK - Support Swiss Knife';
        });
    } else {
      document.title = 'SSK - Support Swiss Knife';
    }

    return () => {
      document.title = 'SSK - Support Swiss Knife';
    };
  }, [id]);

  const [faxNumbers, setFaxNumbers] = useState({
    fax1: '',
    fax2: '',
    fax3: '',
  });

  const handleInputChange = e => {
    const { id, value } = e.target;
    setFaxNumbers(prevState => ({
      ...prevState,
      [id]: value,
    }));
  };

  const copyToClipboard = faxKey => {
    const email = faxNumbers[faxKey]
      ? `${faxNumbers[faxKey]}@efax.ipfone.com`
      : 'efax@efax.ipfone.com';
    navigator.clipboard.writeText(email).then(() => {
      const messageElement = document.getElementById(`${faxKey}-message`);
      if (messageElement) {
        messageElement.textContent = 'Copied to clipboard!';
        messageElement.classList.remove('hidden');
        setTimeout(() => {
          messageElement.textContent = '';
          messageElement.classList.add('hidden');
        }, 2000);
      }
    });
  };

  return (
    <div className='h-screen flex flex-col items-center px-4 pt-5 overflow-y-auto'>
      <div className="grid grid-cols-3 gap-4 w-full">
        {['fax1', 'fax2', 'fax3'].map((faxKey, index) => (
          <div
            key={faxKey}
            className="bg-blue-200 p-12 rounded-xl shadow-lg flex flex-col items-center"
          >
            <img
              className="w-20 h-20"
              src={`${process.env.REACT_APP_CLIENT_URL}/img/fax-machine-icon.png`}
              alt="fax-machine-img"
            />
            <h1 className="font-bold text-2xl">Fax Number {index + 1}</h1>
            <Input
              id={faxKey}
              className="mt-4"
              value={faxNumbers[faxKey]}
              placeholder={`Fax Number ${index + 1}`}
              onChange={handleInputChange}
            />
            <div className="bg-white rounded-xl p-4 mt-4 flex flex-col items-center w-full">
              <h2 className="text-xl font-semibold">
                Copy to send eFax through email
              </h2>
              <h3 className="p-2 text-blue-600 text-xl font-semibold">
                {faxNumbers[faxKey]
                  ? `${faxNumbers[faxKey]}@efax.ipfone.com`
                  : 'efax@efax.ipfone.com'}
              </h3>
              <button
                onClick={() => copyToClipboard(faxKey)}
                className="px-2 py-1 bg-green-600 text-white font-semibold border-b-4 rounded hover:bg-green-500 border-green-800 hover:border-green-700 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  style={{ width: '1.5rem', height: '1.5rem' }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
                  />
                </svg>
                Copy to Clipboard
              </button>
              <p
                id={`${faxKey}-message`}
                className="bg-green-500 text-white mt-2 p-2 inline-block rounded-2xl hidden"
              ></p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Fax;
